import styled, { css } from 'styled-components'

export const SubmissionCreatorNoteAccordionItemStyled = styled.div`
  ${({ active }) =>
    !active &&
    css`
      cursor: pointer;
    `}
`
